var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chart',{staticClass:"chart",attrs:{"option":Object.assign({}, _vm.yuanbing,{series:_vm.carTypeEchart.PieCatTypeData})}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }